// src/helpers/rutaReportes.js
const BASES = [
  // "http://backdanlu.eu-4.evennode.com",   // dev: sin SSL
  "https://backsanpancracio.us-3.evennode.com",  // si más adelante renuevan el SSL
];

export async function getSaldoCliente(clienteId, fechaISO) {
  if (!clienteId) return { ok: false, error: "clienteId requerido" };
  const q = fechaISO ? `?fecha=${encodeURIComponent(fechaISO)}` : "";

  let lastErr;
  for (const base of BASES) {
    const url = `${base.replace(/\/$/,"")}/reportes/saldo-cliente/${clienteId}${q}`;
    try {
      const r = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        // credentials: "include", // habilitar solo si usás cookies cross-site
      });

      const json = await r.json().catch(() => ({}));
      if (!r.ok || json?.ok === false) {
        lastErr = { ok:false, error: json?.error || `HTTP ${r.status}`, tried: url };
        continue;
      }

      // ---- Normalizadores ----
      const toNum  = n => Number(n || 0);
      const toDate = d => (d ? new Date(d) : null);
      const toStr  = v => (v == null ? "" : String(v));

      return {
        ok: true,
        clienteId: json.clienteId,
        fechaCorte: toDate(json.fechaCorte),
        totalSaldoComandas: toNum(json.totalSaldoComandas),

        comandasConSaldo: (json.comandasConSaldo || []).map(i => ({
          ...i,
          // alias robustos (ESTAS claves pisan lo que venga en ...i)
          numero:   toStr(i.numero   ?? i.codcom ?? i.nrodecomanda ?? i.num ?? ""),
          nroviaje: toStr(
            i.nroviaje ?? i.nroViaje ?? i.nro_viaje ??
            i.nro ?? i.nrovia ?? i.nro_via ?? i.nroVia ?? ""
          ),
          fecha:    toDate(i.fecha),
          total:    toNum(i.total),
          aplicado: toNum(i.aplicado),
          saldo:    toNum(i.saldo),
        })),

        ordenesCobroAbiertas: (json.ordenesCobroAbiertas || []).map(i => ({
          ...i,
          total: toNum(i.total),
          fecha: toDate(i.fecha),
        })),
      };


    } catch (e) {
      lastErr = { ok:false, error: e?.message || e, tried: url };
      // si falló https por SSL, el primer base http debería funcionar en dev
      continue;
    }
  }

  console.error("[getSaldoCliente] fallo en todas las bases:", lastErr);
  return { ok: false, error: "No se pudo conectar con el servidor de reportes." };
}

export function toISODate(dateLike) {
  if (!dateLike) return "";
  const d = new Date(dateLike);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
}


export async function getSaldosRemitos(fechaISO) {
  const fecha = fechaISO || new Date().toISOString().slice(0, 10);
  const q = `?fecha=${encodeURIComponent(fecha)}`;

  let lastErr;
  for (const base of BASES) {
    const url = `${base.replace(/\/$/,"")}/reportes/saldos-remitos${q}`;
    try {
      const r = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      const json = await r.json().catch(() => ({}));
      if (!r.ok || json?.ok === false) {
        lastErr = { ok:false, error: json?.msg || json?.error || `HTTP ${r.status}`, tried: url };
        continue;
      }

      const toNum = (n) => Number(n || 0);
      const toStr = (v) => (v == null ? "" : String(v));

      return {
        ok: true,
        fechaCorte: toStr(json.fechaCorte || fecha),

        clientes: (json.clientes || []).map(x => ({
          id: x.id || x._id || "",
          razonsocial: toStr(x.razonsocial),
          saldo: toNum(x.saldo),
          saldoA: toNum(x.saldoA),
          saldoB: toNum(x.saldoB),
        })),

        proveedores: (json.proveedores || []).map(x => ({
          id: x.id || x._id || "",
          razonsocial: toStr(x.razonsocial),
          saldo: toNum(x.saldo),
          saldoA: toNum(x.saldoA),
          saldoB: toNum(x.saldoB),
          saldoFlete: toNum(x.saldoFlete),
        })),

        totales: {
          clientes: toNum(json?.totales?.clientes),
          proveedores: toNum(json?.totales?.proveedores),
          neto: toNum(json?.totales?.neto),
        },
      };
    } catch (e) {
      lastErr = { ok:false, error: e?.message || e, tried: url };
      continue;
    }
  }

  console.error("[getSaldosRemitos] fallo en todas las bases:", lastErr);
  return { ok: false, error: "No se pudo conectar con el servidor de reportes." };
}
